import { render, staticRenderFns } from "./editors-navigation.vue?vue&type=template&id=0e42bdbf&"
import script from "./editors-navigation.vue?vue&type=script&lang=js&"
export * from "./editors-navigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports